import { ApiRes, api } from './client'

export const downloadDocument = (
    membershipDocumentId: string
): ApiRes<string> =>
    api.get('v2/manage/membership_documents/download/' + membershipDocumentId)
